export default __webpack_public_path__ + "static/media/rainbow-right.d3f7d60b.png";